// import React, { useEffect, useMemo, useState } from "react";
// import { useLocation, useNavigate, useParams } from "react-router-dom";
// import {
//   ArrowLeft,
//   MapPin,
//   Phone,
//   CalendarDays,
//   Clock,
//   FileText,
//   AlertTriangle,
//   HeartPulse
// } from "lucide-react";
// import { toast } from "sonner";

// import { useAuth } from "../App";
// import Layout from "../components/Layout";
// import { Card, CardContent } from "../components/ui/card";
// import { Button } from "../components/ui/button";

// const normalizeId = (value) => {
//   if (!value) return "";

//   if (typeof value === "string") {
//     return value.trim();
//   }

//   return String(
//     value._id ||
//     value.id ||
//     value.user_id ||
//     ""
//   ).trim();
// };

// const normalizePatient = (patient, prestation = null) => {
//   if (!patient) return null;

//   return {
//     ...patient,

//     _id:
//       normalizeId(patient) ||
//       normalizeId(prestation?.patient_id),

//     prenom:
//       patient.prenom ||
//       patient.first_name ||
//       "",

//     nom:
//       patient.nom ||
//       patient.last_name ||
//       "",

//     adresse:
//       patient.adresse ||
//       patient.address ||
//       "",

//     telephone:
//       patient.telephone ||
//       patient.phone ||
//       ""
//   };
// };

// const getPatientFromPrestation = (prestation) => {
//   if (!prestation) return null;

//   const candidate =
//     prestation.patient ||
//     (
//       prestation.patient_id &&
//       typeof prestation.patient_id === "object"
//         ? prestation.patient_id
//         : null
//     );

//   return normalizePatient(candidate, prestation);
// };

// const getPatientName = (patient) => {
//   if (!patient) return "Patient";

//   return `${patient.prenom || ""} ${patient.nom || ""}`.trim() || "Patient";
// };

// const passageMeta = {
//   matin: {
//     label: "Matin",
//     icon: "🌅"
//   },
//   midi: {
//     label: "Midi",
//     icon: "☀️"
//   },
//   soir: {
//     label: "Soir",
//     icon: "🌙"
//   }
// };

// const getCarePlan = (patient) => {
//   return (
//     patient?.care_plan ||
//     patient?.plan_soins ||
//     patient?.plan_de_soins ||
//     {}
//   );
// };

// const normalizeCareItems = (value) => {
//   if (Array.isArray(value)) {
//     return value
//       .map((item) => {
//         if (typeof item === "string") return item;

//         return (
//           item?.label ||
//           item?.nom ||
//           item?.name ||
//           item?.description ||
//           ""
//         );
//       })
//       .filter(Boolean);
//   }

//   if (typeof value === "string" && value.trim()) {
//     return value
//       .split(/\n|;/)
//       .map((item) => item.trim())
//       .filter(Boolean);
//   }

//   return [];
// };

// const getPassageDetails = (patient, passage) => {
//   const carePlan = getCarePlan(patient);
//   const data = carePlan?.[passage] || {};

//   const soins = normalizeCareItems(
//     data.soins ||
//     data.prestations ||
//     data.care_items ||
//     patient?.[`soins_${passage}`]
//   );

//   return {
//     heureDebut:
//       data.heure ||
//       data.heure_debut ||
//       data.start_time ||
//       patient?.[`heure_${passage}`] ||
//       "",

//     heureFin:
//       data.heure_fin ||
//       data.end_time ||
//       "",

//     soins,

//     consignes:
//       data.consignes ||
//       data.notes ||
//       data.instructions ||
//       ""
//   };
// };

// export default function PatientCare() {
//   const { axiosInstance } = useAuth();
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { patientId } = useParams();

//   const [patient, setPatient] = useState(
//     normalizePatient(location.state?.patient)
//   );

//   const [prestations, setPrestations] = useState(
//     location.state?.prestation
//       ? [location.state.prestation]
//       : []
//   );

//   const [loading, setLoading] = useState(
//     !location.state?.patient
//   );

//   useEffect(() => {
//     const fetchData = async () => {
//       setLoading(true);

//       try {
//         const response = await axiosInstance.get("/prestations-domicile");

//         const list = Array.isArray(response.data)
//           ? response.data
//           : response.data?.prestations || [];

//         const patientPrestations = list.filter((prestation) => {
//           const prestationPatientId =
//             normalizeId(prestation.patient_id) ||
//             normalizeId(prestation.patient);

//           return prestationPatientId === String(patientId);
//         });

//         setPrestations(patientPrestations);

//         if (!patient) {
//           const patientFound =
//             patientPrestations
//               .map(getPatientFromPrestation)
//               .find(Boolean) ||
//             null;

//           setPatient(patientFound);
//         }
//       } catch (err) {
//         console.error(
//           "Erreur chargement fiche patient :",
//           err.response?.data || err
//         );

//         toast.error(
//           err.response?.data?.detail ||
//           "Impossible de charger la fiche patient."
//         );
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [patientId]);

//   const todayKey = useMemo(() => {
//     const now = new Date();

//     return [
//       now.getFullYear(),
//       String(now.getMonth() + 1).padStart(2, "0"),
//       String(now.getDate()).padStart(2, "0")
//     ].join("-");
//   }, []);

//   const todayPrestations = useMemo(() => {
//     return prestations.filter((prestation) => {
//       if (!prestation?.date) return false;

//       return String(prestation.date).split("T")[0] === todayKey;
//     });
//   }, [prestations, todayKey]);

//   const todayPassages = useMemo(() => {
//     const set = new Set();

//     todayPrestations.forEach((prestation) => {
//       if (Array.isArray(prestation.passages)) {
//         prestation.passages.forEach((passage) => set.add(passage));
//       }
//     });

//     return ["matin", "midi", "soir"].filter((passage) =>
//       set.has(passage)
//     );
//   }, [todayPrestations]);

//   const allPassagesToDisplay = useMemo(() => {
//     if (todayPassages.length > 0) {
//       return todayPassages;
//     }

//     const carePlan = getCarePlan(patient);

//     const configured = ["matin", "midi", "soir"].filter(
//       (passage) => Boolean(carePlan?.[passage])
//     );

//     return configured;
//   }, [todayPassages, patient]);

//   const globalInstructions =
//     patient?.consignes ||
//     patient?.instructions ||
//     patient?.consignes_generales ||
//     patient?.notes_soins ||
//     "";

//   const prestationNotes = todayPrestations
//     .map((prestation) => prestation.notes)
//     .filter(Boolean);

//   if (loading && !patient) {
//     return (
//       <Layout title="Fiche patient">
//         <Card className="mx-auto max-w-4xl border-[#d4ebeb]">
//           <CardContent className="p-8 text-center text-[#4f7d80]">
//             Chargement de la fiche patient…
//           </CardContent>
//         </Card>
//       </Layout>
//     );
//   }

//   if (!patient) {
//     return (
//       <Layout title="Fiche patient">
//         <div className="mx-auto max-w-4xl space-y-4">
//           <Button
//             type="button"
//             onClick={() => navigate("/soins")}
//             className="bg-[#6faeb2] text-white hover:bg-[#5b979b]"
//           >
//             <ArrowLeft size={17} className="mr-2" />
//             Retour aux patients
//           </Button>

//           <Card className="border-red-200 bg-red-50">
//             <CardContent className="p-6 text-center text-red-700">
//               Impossible de retrouver les informations de ce patient.
//             </CardContent>
//           </Card>
//         </div>
//       </Layout>
//     );
//   }

//   return (
//     <Layout title={getPatientName(patient)}>
//       <div className="mx-auto max-w-5xl space-y-6">

//         <Button
//           type="button"
//           onClick={() => navigate("/soins")}
//           className="bg-[#e6f3f3] text-[#315f63] hover:bg-[#d4ebeb]"
//         >
//           <ArrowLeft size={17} className="mr-2" />
//           Mes patients
//         </Button>

//         <Card className="overflow-hidden border-[#d4ebeb]">
//           <div className="bg-[#6faeb2] px-6 py-6 text-white">
//             <p className="text-sm font-medium text-white/80">
//               Fiche opérationnelle
//             </p>

//             <h1 className="mt-1 text-3xl font-bold">
//               {getPatientName(patient)}
//             </h1>
//           </div>

//           <CardContent className="p-6">
//             <div className="grid grid-cols-1 gap-4 text-sm md:grid-cols-2">

//               <div className="flex items-start gap-3">
//                 <MapPin
//                   size={19}
//                   className="mt-0.5 shrink-0 text-[#6faeb2]"
//                 />

//                 <div>
//                   <p className="font-semibold text-[#315f63]">
//                     Adresse
//                   </p>

//                   <p className="text-[#4f7d80]">
//                     {patient.adresse || "Non renseignée"}
//                   </p>
//                 </div>
//               </div>

//               <div className="flex items-start gap-3">
//                 <Phone
//                   size={19}
//                   className="mt-0.5 shrink-0 text-[#6faeb2]"
//                 />

//                 <div>
//                   <p className="font-semibold text-[#315f63]">
//                     Téléphone
//                   </p>

//                   <p className="text-[#4f7d80]">
//                     {patient.telephone || "Non renseigné"}
//                   </p>
//                 </div>
//               </div>

//               <div className="flex items-start gap-3">
//                 <CalendarDays
//                   size={19}
//                   className="mt-0.5 shrink-0 text-[#6faeb2]"
//                 />

//                 <div>
//                   <p className="font-semibold text-[#315f63]">
//                     Date de naissance
//                   </p>

//                   <p className="text-[#4f7d80]">
//                     {patient.date_naissance
//                       ? new Date(
//                           patient.date_naissance
//                         ).toLocaleDateString("fr-BE")
//                       : "Non renseignée"}
//                   </p>
//                 </div>
//               </div>

//             </div>
//           </CardContent>
//         </Card>

//         <div>
//           <div className="mb-4 flex items-center gap-2">
//             <HeartPulse className="text-[#6faeb2]" />
//             <h2 className="text-2xl font-bold text-[#315f63]">
//               Plan de soins
//             </h2>
//           </div>

//           {allPassagesToDisplay.length === 0 ? (
//             <Card className="border-amber-200 bg-amber-50">
//               <CardContent className="p-5">
//                 <p className="font-semibold text-amber-900">
//                   Aucun plan de soins détaillé n’est encore enregistré.
//                 </p>

//                 <p className="mt-2 text-sm text-amber-800">
//                   La prestation est bien attribuée, mais il faut encore
//                   enregistrer les soins du matin, du midi et/ou du soir
//                   dans la fiche patient.
//                 </p>
//               </CardContent>
//             </Card>
//           ) : (
//             <div className="space-y-4">
//               {allPassagesToDisplay.map((passage) => {
//                 const details = getPassageDetails(patient, passage);
//                 const meta = passageMeta[passage];

//                 return (
//                   <Card
//                     key={passage}
//                     className="border-[#d4ebeb] bg-white"
//                   >
//                     <CardContent className="p-5">

//                       <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
//                         <h3 className="text-xl font-bold text-[#315f63]">
//                           {meta?.icon} {meta?.label || passage}
//                         </h3>

//                         {(details.heureDebut || details.heureFin) && (
//                           <div className="inline-flex items-center gap-2 rounded-full bg-blue-50 px-3 py-1 text-sm font-semibold text-blue-700">
//                             <Clock size={15} />

//                             {details.heureDebut || "—"}
//                             {details.heureFin
//                               ? ` – ${details.heureFin}`
//                               : ""}
//                           </div>
//                         )}
//                       </div>

//                       <div className="mt-4">
//                         <p className="mb-2 text-sm font-semibold uppercase tracking-wide text-[#4f7d80]">
//                           Soins à effectuer
//                         </p>

//                         {details.soins.length > 0 ? (
//                           <div className="space-y-2">
//                             {details.soins.map((soin, index) => (
//                               <div
//                                 key={`${passage}-${index}`}
//                                 className="flex items-start gap-3 rounded-xl bg-[#f4fafa] px-4 py-3"
//                               >
//                                 <span className="mt-0.5 font-bold text-green-600">
//                                   ✓
//                                 </span>

//                                 <span className="font-medium text-[#315f63]">
//                                   {soin}
//                                 </span>
//                               </div>
//                             ))}
//                           </div>
//                         ) : (
//                           <p className="rounded-xl bg-gray-50 px-4 py-3 text-sm text-gray-500">
//                             Aucun soin détaillé enregistré pour ce passage.
//                           </p>
//                         )}
//                       </div>

//                       {details.consignes && (
//                         <div className="mt-4 rounded-xl border border-amber-200 bg-amber-50 p-4">
//                           <div className="flex items-center gap-2 font-semibold text-amber-900">
//                             <AlertTriangle size={17} />
//                             Consignes
//                           </div>

//                           <p className="mt-2 whitespace-pre-line text-sm text-amber-900">
//                             {details.consignes}
//                           </p>
//                         </div>
//                       )}

//                     </CardContent>
//                   </Card>
//                 );
//               })}
//             </div>
//           )}
//         </div>

//         {(globalInstructions || prestationNotes.length > 0) && (
//           <Card className="border-amber-200 bg-amber-50">
//             <CardContent className="p-5">
//               <div className="flex items-center gap-2">
//                 <AlertTriangle className="text-amber-700" size={20} />

//                 <h2 className="text-lg font-bold text-amber-900">
//                   Consignes importantes
//                 </h2>
//               </div>

//               {globalInstructions && (
//                 <p className="mt-3 whitespace-pre-line text-sm text-amber-900">
//                   {globalInstructions}
//                 </p>
//               )}

//               {prestationNotes.map((note, index) => (
//                 <p
//                   key={index}
//                   className="mt-3 whitespace-pre-line border-t border-amber-200 pt-3 text-sm text-amber-900"
//                 >
//                   {note}
//                 </p>
//               ))}
//             </CardContent>
//           </Card>
//         )}

//         <Card className="border-[#d4ebeb] bg-[#f4fafa]">
//           <CardContent className="p-5">
//             <div className="flex items-center gap-2">
//               <FileText className="text-[#6faeb2]" size={20} />

//               <h2 className="text-lg font-bold text-[#315f63]">
//                 Documents utiles
//               </h2>
//             </div>

//             <p className="mt-2 text-sm text-[#4f7d80]">
//               Les documents déjà présents dans la fiche patient restent
//               disponibles dans la page Soins. Cette zone pourra ensuite
//               être reliée aux documents autorisés pour le soignant.
//             </p>
//           </CardContent>
//         </Card>

//       </div>
//     </Layout>
//   );
// }


import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  ArrowLeft,
  MapPin,
  Phone,
  CalendarDays,
  Clock,
  UserRound,
  FileText,
  AlertTriangle,
  RefreshCw
} from "lucide-react";
import { toast } from "sonner";

import { useAuth } from "../App";
import Layout from "../components/Layout";
import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";

const normalizeId = (value) => {
  if (!value) return "";

  if (typeof value === "string") {
    return value.trim();
  }

  return String(
    value._id ||
    value.id ||
    value.user_id ||
    ""
  ).trim();
};

const formatDate = (value) => {
  if (!value) return "—";

  try {
    return new Date(value).toLocaleDateString("fr-BE");
  } catch {
    return String(value);
  }
};

const formatDateTime = (value) => {
  if (!value) return "—";

  try {
    return new Date(value).toLocaleString("fr-BE");
  } catch {
    return String(value);
  }
};

const getPatientFromPrestation = (prestation) => {
  const candidate =
    prestation?.patient ||
    (
      prestation?.patient_id &&
      typeof prestation.patient_id === "object"
        ? prestation.patient_id
        : null
    );

  if (!candidate) return null;

  return {
    ...candidate,

    _id:
      normalizeId(candidate) ||
      normalizeId(prestation.patient_id),

    prenom:
      candidate.prenom ||
      candidate.first_name ||
      "",

    nom:
      candidate.nom ||
      candidate.last_name ||
      "",

    adresse:
      candidate.adresse ||
      candidate.address ||
      "",

    telephone:
      candidate.telephone ||
      candidate.phone ||
      ""
  };
};

const normalizePatient = (patient) => {
  if (!patient) return null;

  return {
    ...patient,

    _id: normalizeId(patient),

    prenom:
      patient.prenom ||
      patient.first_name ||
      "",

    nom:
      patient.nom ||
      patient.last_name ||
      "",

    adresse:
      patient.adresse ||
      patient.address ||
      "",

    telephone:
      patient.telephone ||
      patient.phone ||
      ""
  };
};

const getPatientName = (patient) => {
  if (!patient) return "Patient";

  return `${patient.prenom || ""} ${patient.nom || ""}`.trim() || "Patient";
};

const getPassageLabel = (passage) => {
  if (passage === "matin") return "🌅 Matin";
  if (passage === "midi") return "☀️ Midi";
  if (passage === "soir") return "🌙 Soir";

  return passage || "Passage non précisé";
};

const getCaregiverName = (prestation) => {
  const soignant =
    prestation?.soignant ||
    prestation?.soignant_id;

  if (soignant && typeof soignant === "object") {
    const firstName =
      soignant.first_name ||
      soignant.prenom ||
      "";

    const lastName =
      soignant.last_name ||
      soignant.nom ||
      "";

    const fullName = `${firstName} ${lastName}`.trim();

    if (fullName) return fullName;
  }

  return (
    prestation?.soignant_nom ||
    prestation?.caregiver_name ||
    normalizeId(prestation?.soignant_id) ||
    normalizeId(prestation?.soignant_externe_id) ||
    "Soignant non précisé"
  );
};

const getExactTime = (prestation, passage) => {
  if (!prestation) return "";

  // Compatibilité avec plusieurs noms possibles si tu ajoutes l'heure au backend.
  if (prestation.heures && typeof prestation.heures === "object") {
    return prestation.heures[passage] || "";
  }

  if (prestation.horaires && typeof prestation.horaires === "object") {
    return prestation.horaires[passage] || "";
  }

  return (
    prestation[`heure_${passage}`] ||
    prestation.heure ||
    prestation.start_time ||
    ""
  );
};

export default function PatientCare() {
  const { axiosInstance } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { patientId } = useParams();

  const [patient, setPatient] = useState(
    normalizePatient(location.state?.patient)
  );

  const [prestations, setPrestations] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadPatientAndPrestations = async () => {
    setLoading(true);

    try {
      // 1. On récupère toutes les prestations autorisées pour l'utilisateur connecté.
      const prestationResponse = await axiosInstance.get(
        "/prestations-domicile"
      );

      const prestationList = Array.isArray(prestationResponse.data)
        ? prestationResponse.data
        : prestationResponse.data?.prestations || [];

      // 2. On filtre strictement sur le patient de l'URL.
      const matchingPrestations = prestationList.filter(
        (prestation) => {
          const prestationPatientId =
            normalizeId(prestation?.patient_id) ||
            normalizeId(prestation?.patient);

          return prestationPatientId === String(patientId).trim();
        }
      );

      matchingPrestations.sort((a, b) => {
        const aDate = new Date(a.date || 0).getTime();
        const bDate = new Date(b.date || 0).getTime();

        return bDate - aDate;
      });

      setPrestations(matchingPrestations);

      // 3. Si le patient n'a pas été transmis par Soins.jsx,
      //    on tente de le récupérer depuis une prestation enrichie.
      if (!patient) {
        const embeddedPatient = matchingPrestations
          .map(getPatientFromPrestation)
          .find(Boolean);

        if (embeddedPatient) {
          setPatient(embeddedPatient);
        } else {
          // 4. Dernier recours : endpoint patient individuel si disponible.
          try {
            const patientResponse = await axiosInstance.get(
              `/patients/${patientId}`
            );

            const patientData =
              patientResponse.data?.patient ||
              patientResponse.data;

            if (patientData) {
              setPatient(normalizePatient(patientData));
            }
          } catch (patientErr) {
            console.warn(
              "Impossible de récupérer le patient via /patients/:id",
              patientErr.response?.data || patientErr
            );
          }
        }
      }
    } catch (err) {
      console.error(
        "Erreur chargement prestations patient :",
        err.response?.data || err
      );

      toast.error(
        err.response?.data?.detail ||
        "Impossible de charger les prestations de ce patient."
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadPatientAndPrestations();
  }, [patientId]);

  const todayKey = useMemo(() => {
    const now = new Date();

    return [
      now.getFullYear(),
      String(now.getMonth() + 1).padStart(2, "0"),
      String(now.getDate()).padStart(2, "0")
    ].join("-");
  }, []);

  const todayPrestations = useMemo(() => {
    return prestations.filter((prestation) => {
      return String(prestation?.date || "").split("T")[0] === todayKey;
    });
  }, [prestations, todayKey]);

  const nextPrestations = useMemo(() => {
    return prestations
      .filter((prestation) => {
        const dateKey = String(prestation?.date || "").split("T")[0];
        return dateKey > todayKey;
      })
      .sort((a, b) =>
        String(a.date).localeCompare(String(b.date))
      );
  }, [prestations, todayKey]);

  const pastPrestations = useMemo(() => {
    return prestations.filter((prestation) => {
      const dateKey = String(prestation?.date || "").split("T")[0];
      return dateKey < todayKey;
    });
  }, [prestations, todayKey]);

  const renderPrestationCard = (prestation, index, sectionType) => {
    const passages = Array.isArray(prestation.passages)
      ? prestation.passages
      : [];

    return (
      <Card
        key={prestation._id || prestation.id || index}
        className="border-[#d4ebeb] bg-white shadow-sm"
      >
        <CardContent className="p-5">

          <div className="flex flex-col gap-4 md:flex-row md:items-start md:justify-between">

            <div>
              <p className="text-xs font-semibold uppercase tracking-wide text-[#6faeb2]">
                {sectionType}
              </p>

              <div className="mt-1 flex items-center gap-2">
                <CalendarDays
                  size={18}
                  className="text-[#6faeb2]"
                />

                <p className="text-lg font-bold text-[#315f63]">
                  {formatDate(prestation.date)}
                </p>
              </div>
            </div>

            <div className="flex flex-wrap gap-2">
              {passages.length > 0 ? (
                passages.map((passage) => {
                  const heure = getExactTime(prestation, passage);

                  return (
                    <span
                      key={passage}
                      className="rounded-full bg-green-100 px-3 py-1 text-xs font-semibold text-green-700"
                    >
                      {getPassageLabel(passage)}
                      {heure ? ` — ${heure}` : ""}
                    </span>
                  );
                })
              ) : (
                <span className="rounded-full bg-gray-100 px-3 py-1 text-xs font-semibold text-gray-600">
                  Passage non précisé
                </span>
              )}
            </div>

          </div>

          <div className="mt-5 grid grid-cols-1 gap-4 md:grid-cols-2">

            <div className="rounded-xl bg-[#f4fafa] p-4">
              <div className="flex items-center gap-2">
                <UserRound
                  size={17}
                  className="text-[#6faeb2]"
                />

                <p className="text-sm font-semibold text-[#315f63]">
                  Soignant attribué
                </p>
              </div>

              <p className="mt-2 break-all text-sm text-[#4f7d80]">
                {getCaregiverName(prestation)}
              </p>
            </div>

            <div className="rounded-xl bg-[#f4fafa] p-4">
              <div className="flex items-center gap-2">
                <Clock
                  size={17}
                  className="text-[#6faeb2]"
                />

                <p className="text-sm font-semibold text-[#315f63]">
                  Créée le
                </p>
              </div>

              <p className="mt-2 text-sm text-[#4f7d80]">
                {formatDateTime(prestation.created_at)}
              </p>
            </div>

          </div>

          <div className="mt-4 rounded-xl border border-[#d4ebeb] p-4">
            <div className="flex items-center gap-2">
              <FileText
                size={17}
                className="text-[#6faeb2]"
              />

              <p className="text-sm font-semibold text-[#315f63]">
                Notes / consignes de la prestation
              </p>
            </div>

            <p className="mt-2 whitespace-pre-line text-sm text-[#4f7d80]">
              {prestation.notes?.trim()
                ? prestation.notes
                : "Aucune note enregistrée pour cette prestation."}
            </p>
          </div>

          <div className="mt-4 grid grid-cols-1 gap-3 text-xs text-gray-500 sm:grid-cols-2">
            <p>
              <strong>ID prestation :</strong>{" "}
              {prestation._id || prestation.id || "—"}
            </p>

            <p>
              <strong>Dernière modification :</strong>{" "}
              {formatDateTime(prestation.updated_at)}
            </p>
          </div>

        </CardContent>
      </Card>
    );
  };

  return (
    <Layout title="Fiche de soins">
      <div className="mx-auto max-w-5xl space-y-6">

        <div className="flex flex-wrap items-center justify-between gap-3">
          <Button
            type="button"
            onClick={() => navigate("/soins")}
            className="bg-[#e6f3f3] text-[#315f63] hover:bg-[#d4ebeb]"
          >
            <ArrowLeft size={17} className="mr-2" />
            Retour aux patients
          </Button>

          <Button
            type="button"
            onClick={loadPatientAndPrestations}
            className="bg-[#6faeb2] text-white hover:bg-[#5b979b]"
          >
            <RefreshCw size={17} className="mr-2" />
            Actualiser
          </Button>
        </div>

        <Card className="overflow-hidden border-[#d4ebeb] shadow-sm">
          <div className="bg-[#6faeb2] px-6 py-6 text-white">
            <p className="text-sm font-medium text-white/80">
              Patient
            </p>

            <h1 className="mt-1 text-3xl font-bold">
              {getPatientName(patient)}
            </h1>
          </div>

          <CardContent className="p-6">
            {patient ? (
              <div className="grid grid-cols-1 gap-4 md:grid-cols-3">

                <div className="flex items-start gap-3">
                  <MapPin
                    size={18}
                    className="mt-0.5 shrink-0 text-[#6faeb2]"
                  />

                  <div>
                    <p className="font-semibold text-[#315f63]">
                      Adresse
                    </p>

                    <p className="text-sm text-[#4f7d80]">
                      {patient.adresse || "Non renseignée"}
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <Phone
                    size={18}
                    className="mt-0.5 shrink-0 text-[#6faeb2]"
                  />

                  <div>
                    <p className="font-semibold text-[#315f63]">
                      Téléphone
                    </p>

                    <p className="text-sm text-[#4f7d80]">
                      {patient.telephone || "Non renseigné"}
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <CalendarDays
                    size={18}
                    className="mt-0.5 shrink-0 text-[#6faeb2]"
                  />

                  <div>
                    <p className="font-semibold text-[#315f63]">
                      Date de naissance
                    </p>

                    <p className="text-sm text-[#4f7d80]">
                      {formatDate(patient.date_naissance)}
                    </p>
                  </div>
                </div>

              </div>
            ) : (
              <div className="rounded-xl border border-amber-200 bg-amber-50 p-4">
                <div className="flex items-center gap-2 text-amber-900">
                  <AlertTriangle size={18} />

                  <p className="font-semibold">
                    Informations patient non chargées
                  </p>
                </div>

                <p className="mt-2 text-sm text-amber-800">
                  Les prestations peuvent néanmoins être affichées ci-dessous.
                </p>
              </div>
            )}
          </CardContent>
        </Card>

        {loading ? (
          <Card className="border-[#d4ebeb]">
            <CardContent className="p-8 text-center text-[#4f7d80]">
              Chargement des prestations…
            </CardContent>
          </Card>
        ) : prestations.length === 0 ? (
          <Card className="border-amber-200 bg-amber-50">
            <CardContent className="p-6">
              <div className="flex items-center gap-2 text-amber-900">
                <AlertTriangle size={20} />
                <p className="font-semibold">
                  Aucune prestation trouvée pour ce patient.
                </p>
              </div>

              <p className="mt-2 text-sm text-amber-800">
                Vérifie que l’ID patient de la prestation correspond bien à
                celui présent dans l’URL.
              </p>
            </CardContent>
          </Card>
        ) : (
          <>
            <Card className="border-[#d4ebeb] bg-[#f4fafa]">
              <CardContent className="p-5">
                <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
                  <div>
                    <p className="text-sm text-[#4f7d80]">
                      Total prestations
                    </p>
                    <p className="text-2xl font-bold text-[#315f63]">
                      {prestations.length}
                    </p>
                  </div>

                  <div>
                    <p className="text-sm text-[#4f7d80]">
                      Aujourd’hui
                    </p>
                    <p className="text-2xl font-bold text-[#315f63]">
                      {todayPrestations.length}
                    </p>
                  </div>

                  <div>
                    <p className="text-sm text-[#4f7d80]">
                      À venir
                    </p>
                    <p className="text-2xl font-bold text-[#315f63]">
                      {nextPrestations.length}
                    </p>
                  </div>

                  <div>
                    <p className="text-sm text-[#4f7d80]">
                      Historique
                    </p>
                    <p className="text-2xl font-bold text-[#315f63]">
                      {pastPrestations.length}
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>

            {todayPrestations.length > 0 && (
              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-[#315f63]">
                  📍 Prestations d’aujourd’hui
                </h2>

                {todayPrestations.map((prestation, index) =>
                  renderPrestationCard(
                    prestation,
                    index,
                    "Aujourd’hui"
                  )
                )}
              </section>
            )}

            {nextPrestations.length > 0 && (
              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-[#315f63]">
                  📅 Prochaines prestations
                </h2>

                {nextPrestations.map((prestation, index) =>
                  renderPrestationCard(
                    prestation,
                    index,
                    "À venir"
                  )
                )}
              </section>
            )}

            {pastPrestations.length > 0 && (
              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-[#315f63]">
                  🗂 Historique des prestations
                </h2>

                {pastPrestations.map((prestation, index) =>
                  renderPrestationCard(
                    prestation,
                    index,
                    "Historique"
                  )
                )}
              </section>
            )}
          </>
        )}

      </div>
    </Layout>
  );
}